import './styles/Section.scss';
import FontAwesome from "../../../utils/FA";
import PropTypes from "prop-types";
import React from 'react';
import {Link} from "react-router";
import {faPlusCircle} from "@fortawesome/pro-solid-svg-icons/faPlusCircle";
import {faUsers} from "@fortawesome/pro-solid-svg-icons/faUsers";

const Section = ({children, title, addLink, itemName = 'item'}) => {
  return (
    <section className={`sp-profile-section sp-profile-section--${itemName}`}>
      <header>
        <div className="sp-profile-section-header-icon"><FontAwesome icon={faUsers}/></div>
        <div className="sp-profile-section-header-title">{title}</div>

        {addLink && (
          <div className="sp-profile-section-header-add">
            <Link to={addLink} title={`Add ${itemName}`}><FontAwesome icon={faPlusCircle}/></Link>
          </div>
        )}
      </header>

      {children.length === 0 && (
        <div className="sp-profile-section-empty">
          {addLink && (<p>Click the <FontAwesome icon={faPlusCircle}/> above to add a {itemName}</p>)}
          {!addLink && (<p>Add a student to create a {itemName}</p>)}
        </div>
      )}

      {children.length !== 0 && (
        <div className="sp-profile-section-cards">{children}</div>
      )}
    </section>
  );
};

Section.propTypes = {
  /** Section title */
  title: PropTypes.string.isRequired,

  /** Link used to add an item */
  addLink: PropTypes.string,

  /** Item name, i.e. "student" */
  itemName: PropTypes.string,
};

export default Section;
